import cx from 'classnames';
import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import styles from './WorkspacePageHeader.less';

interface WorkspacePageHeaderProps {
  title: ReactNode;
  sticky?: boolean;
}

export const WorkspacePageHeader: FunctionComponent<
  PropsWithChildren<WorkspacePageHeaderProps>
> = ({ title, children, sticky }) => {
  const { value: isM2WorkspaceNavEnabled } = useFeatureGate(
    'billplat_m2_workspace_pages',
  );

  return (
    <header
      className={cx(styles.header, {
        [styles.sticky]: !!sticky,
        [styles.fullscreen]: isM2WorkspaceNavEnabled,
      })}
    >
      <h1 className={styles.title}>{title}</h1>
      {children}
    </header>
  );
};
